export default __webpack_public_path__ + "static/media/CargoDetailsIcon.1d73bfa7.svg";